var productArray = [];
 


productArray.push({
	sku: pers_product_sku,
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: pers_textSize,
			yB: pers_textPosition.yb, //Left top corner (Vert)
			xL: pers_textPosition.xl, //Left top corner (Hor)
			yT: pers_textPosition.yt, //Right Bottom corner (Vert)
			xR: pers_textPosition.xr, //Right Bottom corner (Hor)
			bespokeValue: pers_defaultText,
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: pers_textColour,
			lineHeight: 260
		}
	]
});


productArray.push({
	sku: "BRNFR001_HOODIE",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 525,
            yB: 625,
			bespokeValue: "CHEETAH",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#F69578",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR002_HOODIE",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 535,
            yB: 635,
			bespokeValue: "ELEPHANT",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#b24e26",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR003_HOODIE",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 540,
            yB: 640,
			bespokeValue: "GIRAFFE",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#fed865",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR004_HOODIE",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 540,
            yB: 640,
			bespokeValue: "GORILLA",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#2d2e30",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR005_HOODIE",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 545,
            yB: 645,
			bespokeValue: "LION",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#ff9e21",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR006_HOODIE",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 525,
            yB: 625,
			bespokeValue: "LIONESS",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#f79578",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR007_HOODIE",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 520,
            yB: 620,
			bespokeValue: "ORANGUTAN",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#91361F",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR008_HOODIE",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 525,
            yB: 625,
			bespokeValue: "RHINO",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#b24e26",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR001_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 500,
            yB: 600,
			bespokeValue: "CHEETAH",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#F69578",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR002_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 500,
            yB: 600,
			bespokeValue: "ELEPHANT",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#b24e26",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR003_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 540,
            yB: 640,
			bespokeValue: "GIRAFFE",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#fed865",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR004_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 540,
            yB: 640,
			bespokeValue: "GORILLA",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#2d2e30",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR005_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 540,
            yB: 640,
			bespokeValue: "LION",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#ff9e21",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR006_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 500,
            yB: 600,
			bespokeValue: "LIONESS",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#f79578",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR007_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 500,
            yB: 600,
			bespokeValue: "ORANGUTAN",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#91361F",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "BRNFR008_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 90,
			xL: 360,
            xR: 660,
			yT: 540,
            yB: 640,
			bespokeValue: "RHINO",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#b24e26",
			lineHeight: 260
		}
	]
});



/*
productArray.push({
	sku: "BRNFR001_CUSHION",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 100,
			yB: 780, //Left top corner (Vert)
			xL: 320, //Left top corner (Hor)
			yT: 680, //Right Bottom corner (Vert)
			xR: 700, //Right Bottom corner (Hor)
			bespokeValue: "CHEETAH",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'BornFree',
			primaryFontColor: "#F69578",
			lineHeight: 260
		}
	]
});

*/

/*
productArray.push({
	sku:"BRNFR001_CUSHION",
	originalFontSize:100,
	xL:320,
	yT:680,
	xR:700,
	yB:780,
	bespokeValue:"Cheetah",
	canvasHeight:1024,
	canvasWidth:1024,
	primaryFontColor:"#F69578"
});

productArray.push({
	sku:"TEST_BRNFR003_PRINT",
	originalFontSize:120,
	xL:280,
	yT:780,
	xR:740,
	yB:880,
	bespokeValue:"Giraffe",
	canvasHeight:1024,
	canvasWidth:1024,
	primaryFontColor:"#FED865"
});


*/

